import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKHonorDark = () => (
  <ArticleWrapper articleId="gmk_honor_dark">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Honor Dark</h1>
        {/* Add your GMK Honor Dark article content here */}
        <p>This is a placeholder article for the GMK Honor Dark keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKHonorDark;
